import { useEffect, useState } from 'react'
import GridContainer from '../../Component/common/field/GridContainer'
import { getOne, post, put } from '../../helper/baseFetch'
import { useSelector, useStore } from 'react-redux'
import CardTitle from '../../Component/common/card/CardTitle'
import MUIInput from '../../Component/common/field/MUIInput'
import MUISelect from '../../Component/common/field/MUISelect'
import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Drawer,
    IconButton,
    Stack,
} from '@mui/material'
import { TempBtn } from '../../Component/Input/TempBtn'
import { ArrowBack, Clear, Edit, GetApp, List, Save } from '@mui/icons-material'
import { ProductCategoryList } from '../../Component/ProductCreate/Category/ProductCategoryList'
import { ProductList } from '../../Component/ProductCreate/Product/ProductList'
import { FolderList } from '../Folder/FolderList'
import { RestaurantList } from '../Restaurant/RestaurantList'
import { BrandList } from '../Brand/BrandList'
import SharedDialog from '../../Component/common/dialog/SharedDialog'
import { useHistory, useParams } from 'react-router-dom'
import {
    ACTION_OPTION,
    ACTION_TYPE,
    ACTION_TYPE_OPTION,
    AGENT_TYPE_OPTION,
    CODE_TYPE_OPTION,
    STATIC_DATA_DEFAULT,
    DOWNLOAD_HTML_URL,
    FOLDER_TYPE_OPTION,
    FROM_OPTION,
    GIFT_SERVICE_TYPE_OPTION,
    DYNAMIC_DATA_DEFAULT,
    Q_HK_WALLET_URL,
    QUERY_OPTION,
    RACK_PRODUCT_TYPE_OPTION,
    REST_URL_TYPE,
    REST_URL_TYPE_OPTION,
    SERVICE_TYPE_OPTION,
    WEB_VIEW_TYPE_OPTION,
} from '../../Constants/urlMap'
import QRCode from 'qrcode.react'
import { getRestaurantUrlType, getRestUrlIdFromUrl } from '../../helper/urlUtil'
import { API_PATH, ROUTER_PATH } from '../../Constants/path'

export default function UrlMap({ isCreateMode = true }) {
    const store = useStore()

    // Static Data
    const [staticData, setStaticData] = useState(STATIC_DATA_DEFAULT)
    const [url, setUrl] = useState('')

    // Dynamic Data - will be cleared when action type changed
    const [dynamicData, setDynamicData] = useState(DYNAMIC_DATA_DEFAULT)
    const [dynamicDataFields, setDynamicDataFields] = useState([])

    const [openDrawer, setOpenDrawer] = useState(false)
    const [openDialog, setOpenDialog] = useState(false)
    const [showQrCode, setShowQrCode] = useState(false)

    const history = useHistory()
    const lang = useSelector((state) => state.lang.ui.lang)

    const [error, setError] = useState({})

    const params = useParams()

    const resetDynamicDataFields = (actionType) => {
        switch (actionType) {
            case ACTION_TYPE.WEB_VIEW:
                setDynamicDataFields(['action', 'title', 'type'])
                break
            case ACTION_TYPE.LINK:
                setDynamicDataFields(['action'])
                break
            case ACTION_TYPE.VIDEO:
                setDynamicDataFields(['action'])
                break
            case ACTION_TYPE.PRODUCT:
                setDynamicDataFields(['productCode'])
                break
            case ACTION_TYPE.PRODUCT_CATEGORY:
                setDynamicDataFields(['categoryCode'])
                break
            case ACTION_TYPE.PRODUCT_BRAND:
                setDynamicDataFields(['brandCode'])
                break
            case ACTION_TYPE.E_COUPON:
                setDynamicDataFields(['eCouponCode'])
                break
            case ACTION_TYPE.E_COUPON_CATEGORY:
                setDynamicDataFields(['categoryCode'])
                break
            case ACTION_TYPE.E_COUPON_BRAND:
                setDynamicDataFields(['brandCode'])
                break
            case ACTION_TYPE.FOLDER:
                setDynamicDataFields(['folderCode', 'folderType'])
                break
            case ACTION_TYPE.REST:
                setDynamicDataFields(['action', 'queryRestUrlId'])
                break
            case ACTION_TYPE.SEARCH:
                setDynamicDataFields(['name', 'query'])
                break
            case ACTION_TYPE.BOOKMARK:
                setDynamicDataFields([])
                break
            case ACTION_TYPE.SEARCH_NEAR_BY:
                setDynamicDataFields([])
                break
            case ACTION_TYPE.MY_TICKET:
                setDynamicDataFields(['refId', 'serviceType'])
                break
            case ACTION_TYPE.TRANSFORM_TICKET_FROM_PAPER:
                setDynamicDataFields(['ticketId'])
                break
            case ACTION_TYPE.TRANSFORM_ECOUPON_FROM_PAPER:
                setDynamicDataFields(['infoId'])
                break
            case ACTION_TYPE.EXPRESS_TICKET_VOUCHER:
                setDynamicDataFields(['groupCode'])
                break
            case ACTION_TYPE.SHARE:
                setDynamicDataFields(['serviceType', 'refId'])
                break
            case ACTION_TYPE.GIFT:
                setDynamicDataFields(
                    dynamicData.serviceType === 'RACK_PRODUCT'
                        ? ['serviceType', 'refId', 'code', 'type']
                        : ['serviceType', 'refId', 'code']
                )
                break
            case ACTION_TYPE.LANDING:
                setDynamicDataFields([])
                break
            case ACTION_TYPE.DOWNLOAD:
                setDynamicDataFields([])
                break
            case ACTION_TYPE.SCAN_QRCODE:
                setDynamicDataFields([])
                break
            case ACTION_TYPE.CUSTOM_URL:
                setDynamicDataFields(['customUrl'])
                break
            default:
                setDynamicDataFields([])
                break
        }
    }

    const resetUrl = (staticData, dynamicData) => {
        const fromQuery = `${dynamicData.from ? `&from=${dynamicData.from}` : ''}`

        switch (staticData.actionType) {
            case ACTION_TYPE.WEB_VIEW:
                setUrl(
                    `${DOWNLOAD_HTML_URL}?web=action=${dynamicData.action}${
                        dynamicData.type ? `&type=${dynamicData.type}` : ''
                    }${dynamicData.title ? `&title=${dynamicData.title}` : ''}${fromQuery}`
                )
                break
            case ACTION_TYPE.LINK:
                setUrl(`${DOWNLOAD_HTML_URL}?link=action=${dynamicData.action}${fromQuery}`)
                break
            case ACTION_TYPE.VIDEO:
                setUrl(`${DOWNLOAD_HTML_URL}?web=action=${dynamicData.action}${fromQuery}`)
                break
            case ACTION_TYPE.PRODUCT:
                let codeTypeQuery = ''

                if (dynamicData.codeType === 'CATEGORY') {
                    codeTypeQuery = `&categoryCode=${dynamicData.categoryCode}`
                } else if (dynamicData.codeType === 'BRAND') {
                    codeTypeQuery = `&brandCode=${dynamicData.brandCode}`
                }

                setUrl(
                    `${DOWNLOAD_HTML_URL}?product=productCode=${dynamicData.productCode}${codeTypeQuery}${fromQuery}`
                )
                break
            case ACTION_TYPE.PRODUCT_CATEGORY:
                setUrl(
                    `${DOWNLOAD_HTML_URL}?product=categoryCode=${dynamicData.categoryCode}${fromQuery}`
                )
                break
            case ACTION_TYPE.PRODUCT_BRAND:
                setUrl(`${DOWNLOAD_HTML_URL}?product=brandCode=${dynamicData.brandCode}${fromQuery}`)
                break
            case ACTION_TYPE.E_COUPON:
                setUrl(
                    `${DOWNLOAD_HTML_URL}?e-coupon=ecouponCode=${dynamicData.eCouponCode}${
                        dynamicData.codeType
                            ? dynamicData.codeType === 'CATEGORY'
                                ? `&categoryCode=${dynamicData.categoryCode}`
                                : `&brandCode=${dynamicData.brandCode}`
                            : ''
                    }${fromQuery}`
                )
                break
            case ACTION_TYPE.E_COUPON_CATEGORY:
                setUrl(
                    `${DOWNLOAD_HTML_URL}?e-coupon=categoryCode=${dynamicData.categoryCode}${fromQuery}`
                )
                break
            case ACTION_TYPE.E_COUPON_BRAND:
                setUrl(`${DOWNLOAD_HTML_URL}?e-coupon=brandCode=${dynamicData.brandCode}${fromQuery}`)
                break
            case ACTION_TYPE.FOLDER:
                setUrl(
                    `${DOWNLOAD_HTML_URL}?redirect_folder=folderCode=${dynamicData.folderCode}${
                        dynamicData.folderType ? `&folderType=${dynamicData.folderType}` : ''
                    }${fromQuery}`
                )
                break
            case ACTION_TYPE.REST:
                if (staticData.restUrlType === REST_URL_TYPE.universal) {
                    setUrl(
                        `${process.env.REACT_APP_GULU_WEB_BASE}app/shop${
                            dynamicData.queryRestUrlId ? `/${dynamicData.queryRestUrlId}` : ''
                        }`
                    )
                }

                if (staticData.restUrlType === REST_URL_TYPE.downloadHtml) {
                    setUrl(
                        `${DOWNLOAD_HTML_URL}?redirect_rest=${
                            dynamicData.queryRestUrlId ? `restUrlId=${dynamicData.queryRestUrlId}` : ''
                        }${dynamicData.action ? `&action=${dynamicData.action}` : ''}${fromQuery}`
                    )
                }

                if (staticData.restUrlType === REST_URL_TYPE.other) {
                    setUrl(dynamicData.customUrl)
                }

                break
            case ACTION_TYPE.SEARCH:
                setUrl(
                    `${DOWNLOAD_HTML_URL}?search=${
                        dynamicData.name ? `&name=${dynamicData.name}` : ''
                    }${dynamicData.query ? `&query=${dynamicData.query}` : ''}${fromQuery}`
                )
                break
            case ACTION_TYPE.BOOKMARK:
                setUrl(`${DOWNLOAD_HTML_URL}?bookmark=${fromQuery}`)
                break
            case ACTION_TYPE.SEARCH_NEAR_BY:
                setUrl(`${DOWNLOAD_HTML_URL}?searchnearby=${fromQuery}`)
                break
            case ACTION_TYPE.MY_TICKET:
                setUrl(
                    `${DOWNLOAD_HTML_URL}?myticket=refId=${dynamicData.refId}&serviceType=${dynamicData.serviceType}${fromQuery}`
                )
                break
            case ACTION_TYPE.TRANSFORM_TICKET_FROM_PAPER:
                setUrl(
                    `${DOWNLOAD_HTML_URL}?transformticketfrompaper=ticketId=${dynamicData.ticketId}${fromQuery}`
                )
                break
            case ACTION_TYPE.TRANSFORM_ECOUPON_FROM_PAPER:
                setUrl(
                    `${DOWNLOAD_HTML_URL}?transformecouponfrompaper=infoId=${dynamicData.infoId}${fromQuery}`
                )
                break
            case ACTION_TYPE.EXPRESS_TICKET_VOUCHER:
                setUrl(
                    `${DOWNLOAD_HTML_URL}?expressticketvoucher=groupCode=${dynamicData.groupCode}${fromQuery}`
                )
                break
            case ACTION_TYPE.SHARE:
                setUrl(
                    `${DOWNLOAD_HTML_URL}?share=refId=${dynamicData.refId}&serviceType=${dynamicData.serviceType}${fromQuery}`
                )
                break
            case ACTION_TYPE.GIFT:
                setUrl(
                    `${DOWNLOAD_HTML_URL}?gift=refId=${dynamicData.refId}&code=${
                        dynamicData.code
                    }&serviceType=${dynamicData.serviceType}${
                        dynamicData.serviceType === 'RACK_PRODUCT' ? `&type=${dynamicData.type}` : ''
                    }${fromQuery}`
                )
                break
            case ACTION_TYPE.LANDING:
                setUrl(`${DOWNLOAD_HTML_URL}?landing=${fromQuery}`)
                break
            case ACTION_TYPE.DOWNLOAD:
                setUrl(`${DOWNLOAD_HTML_URL}?download=${fromQuery}`)
                break
            case ACTION_TYPE.SCAN_QRCODE:
                setUrl(`${DOWNLOAD_HTML_URL}?scanqrcode=${fromQuery}`)
                break
            case ACTION_TYPE.CUSTOM_URL:
                setUrl(`${dynamicData.customUrl}${fromQuery}`)
                break
            default:
                break
        }
    }

    const onChangeInput = (key, value, dataType = 'default') => {
        if (showQrCode) {
            setShowQrCode(false)
        }

        switch (dataType) {
            case 'default':
                const newStaticData = { ...staticData, [key]: value }

                if (key === 'actionType') {
                    setStaticData(newStaticData)
                    setDynamicData(DYNAMIC_DATA_DEFAULT)
                    resetUrl(newStaticData, DYNAMIC_DATA_DEFAULT)
                    return
                }

                if (key === 'restUrlType') {
                    setStaticData(newStaticData)
                    setDynamicData(DYNAMIC_DATA_DEFAULT)
                    resetUrl(newStaticData, DYNAMIC_DATA_DEFAULT)
                    return
                }

                if (key === 'agentType' && value === 'weChat') {
                    setStaticData({
                        ...staticData,
                        [key]: value,
                    })
                    setDynamicData(DYNAMIC_DATA_DEFAULT)
                    setUrl(`${Q_HK_WALLET_URL}${dynamicData.weChat ? `?${dynamicData.weChat}` : ''}`)
                    return
                }

                setStaticData(newStaticData)
                resetUrl(newStaticData, dynamicData)
                break
            default:
                const newOtherData = { ...dynamicData, [key]: value }
                setDynamicData(newOtherData)
                resetUrl(staticData, newOtherData)
                break
        }
    }

    const onClickListRow = (key, value) => {
        setDynamicData({ ...dynamicData, [key]: value })
        resetUrl(staticData, { ...dynamicData, [key]: value })
        onCloseDrawer()
    }

    const onOpenDrawer = () => {
        setOpenDrawer(true)
    }

    const onCloseDrawer = () => {
        setOpenDrawer(false)
    }

    const onOpenDialog = () => {
        setOpenDialog(true)
    }

    const onCloseDialog = () => {
        setOpenDialog(false)
    }

    const validateUrlMap = (staticData, dynamicData) => {
        const newError = {}

        const requiredErrorMsg = 'Required'

        if (!staticData.agentType) {
            newError.agentType = requiredErrorMsg
        }

        if (staticData.mapCode && !staticData.mapCode.match('^[A-Z0-9_]+$')) {
            newError.mapCode = 'Only uppercase letters, numbers and underscore allowed'
        }

        if (staticData.agentType === 'web' && !staticData.actionType) {
            newError.actionType = requiredErrorMsg
        } else {
            switch (staticData.actionType) {
                case ACTION_TYPE.MY_TICKET:
                    if (!dynamicData.serviceType) {
                        newError.serviceType = requiredErrorMsg
                    }

                    if (dynamicData.serviceType === 'RACK_PRODUCT' && !dynamicData.type) {
                        newError.type = requiredErrorMsg
                    }

                    if (!dynamicData.refId) {
                        newError.refId = requiredErrorMsg
                    }
                    break
                case ACTION_TYPE.TRANSFORM_ECOUPON_FROM_PAPER:
                    if (!dynamicData.infoId) {
                        newError.infoId = requiredErrorMsg
                    }
                    break
                case ACTION_TYPE.TRANSFORM_TICKET_FROM_PAPER:
                    if (!dynamicData.ticketId) {
                        newError.ticketId = requiredErrorMsg
                    }
                    break
                case ACTION_TYPE.EXPRESS_TICKET_VOUCHER:
                    if (!dynamicData.groupCode) {
                        newError.groupCode = requiredErrorMsg
                    }
                    break
                case ACTION_TYPE.GIFT:
                    if (!dynamicData.refId) {
                        newError.refId = requiredErrorMsg
                    }

                    if (!dynamicData.code) {
                        newError.code = requiredErrorMsg
                    }

                    if (!dynamicData.serviceType) {
                        newError.serviceType = requiredErrorMsg
                    }

                    if (dynamicData.serviceType === 'RACK_PRODUCT' && !dynamicData.type) {
                        newError.type = requiredErrorMsg
                    }

                    break
                case ACTION_TYPE.SHARE:
                    if (!dynamicData.refId) {
                        newError.refId = requiredErrorMsg
                    }

                    if (!dynamicData.serviceType) {
                        newError.serviceType = requiredErrorMsg
                    }

                    break
                case ACTION_TYPE.WEB_VIEW:
                case ACTION_TYPE.LINK:
                case ACTION_TYPE.VIDEO:
                    if (!dynamicData.action) {
                        newError.action = requiredErrorMsg
                    }
                    break
                case ACTION_TYPE.PRODUCT:
                    if (!dynamicData.productCode) {
                        newError.productCode = requiredErrorMsg
                    }

                    if (dynamicData.codeType === 'BRAND' && !dynamicData.brandCode) {
                        newError.brandCode = requiredErrorMsg
                    }

                    if (dynamicData.codeType === 'CATEGORY' && !dynamicData.categoryCode) {
                        newError.categoryCode = requiredErrorMsg
                    }

                    break
                case ACTION_TYPE.PRODUCT_CATEGORY:
                case ACTION_TYPE.E_COUPON_CATEGORY:
                    if (!dynamicData.categoryCode) {
                        newError.categoryCode = requiredErrorMsg
                    }
                    break
                case ACTION_TYPE.PRODUCT_BRAND:
                case ACTION_TYPE.E_COUPON_BRAND:
                    if (!dynamicData.brandCode) {
                        newError.brandCode = requiredErrorMsg
                    }
                    break
                case ACTION_TYPE.E_COUPON:
                    if (!dynamicData.eCouponCode) {
                        newError.eCouponCode = requiredErrorMsg
                    }

                    if (dynamicData.codeType === 'BRAND' && !dynamicData.brandCode) {
                        newError.brandCode = requiredErrorMsg
                    }

                    if (dynamicData.codeType === 'CATEGORY' && !dynamicData.categoryCode) {
                        newError.categoryCode = requiredErrorMsg
                    }

                    break
                case ACTION_TYPE.FOLDER:
                    if (!dynamicData.folderCode) {
                        newError.folderCode = requiredErrorMsg
                    }
                    break
                case ACTION_TYPE.REST:
                    if (!staticData.restUrlType) {
                        newError.restUrlType = requiredErrorMsg
                    }

                    if (
                        (staticData.restUrlType === REST_URL_TYPE.downloadHtml ||
                            staticData.restUrlType === REST_URL_TYPE.universal) &&
                        !dynamicData.queryRestUrlId
                    ) {
                        newError.queryRestUrlId = requiredErrorMsg
                    }
                    break
                case ACTION_TYPE.CUSTOM_URL:
                    if (!dynamicData.customUrl) {
                        newError.customUrl = requiredErrorMsg
                    }
                    break
                default:
            }
        }

        setError(newError)
    }

    const renderDrawerList = () => {
        let component

        const dialogFooterBtn = (
            <TempBtn
                btnSetting={{
                    onClick: onCloseDrawer,
                    icon: <Clear />,
                    label: { key: 'close' },
                }}
            />
        )

        switch (staticData.actionType) {
            case ACTION_TYPE.PRODUCT:
                component = (
                    <ProductList
                        newFilter={{
                            excludedTypeList: ['PACKAGE_SUB_ITEM', 'FREE_ECOUPON_ITEM'],
                        }}
                        editBtn={false}
                        createBtn={false}
                        onClickListRow={(item) => onClickListRow('productCode', item.productCode)}
                        dialogFooterBtn={dialogFooterBtn}
                    />
                )

                if (dynamicData.codeType) {
                    component =
                        dynamicData.codeType === 'CATEGORY' ? (
                            <ProductCategoryList
                                newFilter={{
                                    typeList: ['PRODUCT', 'ALL'],
                                }}
                                editBtn={false}
                                createBtn={false}
                                onClickListRow={(item) =>
                                    onClickListRow('categoryCode', item.categoryCode)
                                }
                                dialogFooterBtn={dialogFooterBtn}
                            />
                        ) : (
                            <BrandList
                                editBtn={false}
                                createBtn={false}
                                onClickListRow={(item) =>
                                    onClickListRow('brandCode', item.brandCode)
                                }
                                dialogFooterBtn={dialogFooterBtn}
                            />
                        )
                }

                break
            case ACTION_TYPE.PRODUCT_CATEGORY:
                component = (
                    <ProductCategoryList
                        newFilter={{
                            typeList: ['PRODUCT', 'ALL'],
                        }}
                        editBtn={false}
                        createBtn={false}
                        onClickListRow={(item) => onClickListRow('categoryCode', item.categoryCode)}
                        dialogFooterBtn={dialogFooterBtn}
                    />
                )

                break
            case ACTION_TYPE.E_COUPON:
                component = (
                    <ProductList
                        newFilter={{
                            type: 'FREE_ECOUPON_ITEM',
                            excludedTypeList: ['PACKAGE_SUB_ITEM'],
                        }}
                        editBtn={false}
                        createBtn={false}
                        onClickListRow={(item) => onClickListRow('eCouponCode', item.productCode)}
                        dialogFooterBtn={dialogFooterBtn}
                    />
                )

                if (dynamicData.codeType) {
                    component =
                        dynamicData.codeType === 'CATEGORY' ? (
                            <ProductCategoryList
                                newFilter={{
                                    typeList: ['FREE_ECOUPON', 'ALL'],
                                }}
                                editBtn={false}
                                createBtn={false}
                                onClickListRow={(item) =>
                                    onClickListRow('categoryCode', item.categoryCode)
                                }
                                dialogFooterBtn={dialogFooterBtn}
                            />
                        ) : (
                            <BrandList
                                editBtn={false}
                                createBtn={false}
                                onClickListRow={(item) =>
                                    onClickListRow('brandCode', item.brandCode)
                                }
                                dialogFooterBtn={dialogFooterBtn}
                            />
                        )
                }

                break
            case ACTION_TYPE.E_COUPON_CATEGORY:
                component = (
                    <ProductCategoryList
                        newFilter={{
                            typeList: ['FREE_ECOUPON', 'ALL'],
                        }}
                        editBtn={false}
                        createBtn={false}
                        onClickListRow={(item) => onClickListRow('categoryCode', item.categoryCode)}
                        dialogFooterBtn={dialogFooterBtn}
                    />
                )
                break
            case ACTION_TYPE.PRODUCT_BRAND:
            case ACTION_TYPE.E_COUPON_BRAND:
                component = (
                    <BrandList
                        editBtn={false}
                        createBtn={false}
                        onClickListRow={(item) => onClickListRow('brandCode', item.brandCode)}
                        dialogFooterBtn={dialogFooterBtn}
                    />
                )
                break
            case ACTION_TYPE.PRODUCT_COUPON_CATEGORY_MAP:
                component = (
                    <ProductCategoryList
                        newFilter={{
                            productCode: dynamicData.productCode || dynamicData.eCouponCode,
                        }}
                        editBtn={false}
                        createBtn={false}
                        onClickListRow={(item) => onClickListRow('categoryCode', item.categoryCode)}
                        dialogFooterBtn={dialogFooterBtn}
                    />
                )
                break
            case ACTION_TYPE.PRODUCT_COUPON_BRAND_MAP:
                component = (
                    <BrandList
                        editBtn={false}
                        createBtn={false}
                        newFilter={{
                            productCode: dynamicData.productCode || dynamicData.eCouponCode,
                        }}
                        onClickListRow={(item) => onClickListRow('productCode', item.productCode)}
                        dialogFooterBtn={dialogFooterBtn}
                    />
                )
                break
            case ACTION_TYPE.FOLDER:
                component = (
                    <FolderList
                        editBtn={false}
                        createBtn={false}
                        onClickListRow={(item) => onClickListRow('folderCode', item.folderCode)}
                        dialogFooterBtn={dialogFooterBtn}
                    />
                )
                break
            case ACTION_TYPE.REST:
                component = (
                    <RestaurantList
                        editBtn={false}
                        createBtn={false}
                        btnList={false}
                        onClickListRow={(item) => onClickListRow('queryRestUrlId', item.restUrlId)}
                        dialogFooterBtn={dialogFooterBtn}
                    />
                )
                break
            default:
                component = <></>
                break
        }

        return <>{component}</>
    }

    const OpenDrawerEndAdornment = () => {
        return (
            <IconButton onClick={onOpenDrawer} color='primary'>
                <Edit sx={{ width: '20px', height: '20px' }} />
            </IconButton>
        )
    }

    const onClickSave = () => {
        const body = {
            actionType: staticData.actionType,
            mapCode: staticData.mapCode,
            mapValue: staticData.mapValue,
            url: url,
            qrCodeUrl: staticData.qrCodeUrl,
            agentType: staticData.agentType,
            restUrlId: staticData.restUrlId,
        }

        isCreateMode
            ? post(
                  API_PATH.urlMap,
                  body,
                  () => {
                      onOpenDialog()
                  },
                  undefined,
                  store
              )
            : put(
                  `${API_PATH.urlMap}/${params.id}`,
                  body,
                  () => {
                      onOpenDialog()
                  },
                  undefined,
                  store
              )
    }

    const onClickClear = () => {
        if (isCreateMode) {
            setStaticData(STATIC_DATA_DEFAULT)
            setDynamicData(DYNAMIC_DATA_DEFAULT)
        } else {
            getUrlMap()
            setShowQrCode(true)
        }
    }

    const onClickBackToCreateEdit = () => {
        onCloseDialog()
    }

    const onClickBackToList = () => {
        onCloseDialog()
        history.push(ROUTER_PATH.urlMap)
    }

    const getQueryObj = (url) => {
        if (!url) {
            return {}
        }

        // eslint-disable-next-line no-unused-vars
        const [_, queryStr] = url.split(/=(.+)/)

        if (!queryStr) {
            return {}
        }

        const queryObj = queryStr.split('&').reduce((result, pair) => {
            const [key, value] = pair.split('=')
            result[key] = value
            return result
        }, {})

        return queryObj
    }

    const getUrlMap = () => {
        getOne(
            `${API_PATH.urlMap}/${params.id}`,
            undefined,
            (payload) => {
                let newStaticData = { ...STATIC_DATA_DEFAULT }
                let newDynamicData = { ...DYNAMIC_DATA_DEFAULT }

                newStaticData = {
                    ...newStaticData,
                    mapCode: payload.mapCode,
                    mapValue: payload.mapValue,
                    actionType: payload.actionType,
                    agentType: payload.agentType,
                    restUrlId: payload.restUrlId,
                    status: payload.status,
                    qrCodeUrl: payload.qrCodeUrl,
                }

                if (payload.agentType === 'weChat') {
                    newDynamicData = {
                        ...newDynamicData,
                        weChat: payload.url.split('?')[1],
                    }
                } else if (payload.actionType === ACTION_TYPE.REST) {
                    const restUrlType = getRestaurantUrlType(payload.url)
                    const queryRestUrlId = getRestUrlIdFromUrl(payload.url)

                    newStaticData = {
                        ...newStaticData,
                        restUrlType: restUrlType,
                    }

                    if (restUrlType === REST_URL_TYPE.other) {
                        newDynamicData = {
                            ...newDynamicData,
                            customUrl: payload.url,
                        }
                    } else {
                        const queryObj = getQueryObj(payload.url)

                        Object.entries(queryObj).forEach(([key, value]) => {
                            newDynamicData[key] = value
                        })

                        newDynamicData = {
                            ...newDynamicData,
                            queryRestUrlId: queryRestUrlId,
                        }
                    }
                } else {
                    const queryObj = getQueryObj(payload.url)

                    Object.entries(queryObj).forEach(([key, value]) => {
                        newDynamicData[key] = value
                    })
                }

                setUrl(payload.url)
                setStaticData(newStaticData)
                setDynamicData(newDynamicData)
            },
            undefined,
            store
        )
    }

    const onClickDownloadQrCode = () => {
        const svg = document.getElementById('qrCode')
        const s = new XMLSerializer().serializeToString(svg)
        const src = `data:image/svg+xml;base64,${window.btoa(s)}`
        const img = new Image()
        img.src = src
        img.onload = () => {
            const canvas = document.createElement('canvas')
            canvas.width = 1000
            canvas.height = 1000
            const context = canvas.getContext('2d')
            context.drawImage(img, 0, 0, 1000, 1000)
            const ImgBase64 = canvas.toDataURL('image/png')
            let downloadLink = document.createElement('a')
            downloadLink.href = ImgBase64
            downloadLink.download = `${window.btoa(s)}.png`
            document.body.appendChild(downloadLink)
            downloadLink.click()
            document.body.removeChild(downloadLink)
        }
    }

    useEffect(() => {
        validateUrlMap(staticData, dynamicData)
    }, [staticData, dynamicData])

    useEffect(() => {
        resetDynamicDataFields(staticData.actionType)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [staticData.actionType])

    useEffect(() => {
        if (!isCreateMode) {
            getUrlMap()
            setShowQrCode(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <Card sx={{ p: 2 }}>
                <CardHeader
                    title={<CardTitle>{`Url Map ${isCreateMode ? 'Create' : 'Edit'}`} </CardTitle>}
                />
                <CardContent>
                    <Stack gap={1}>
                        <GridContainer>
                            {!isCreateMode && (
                                <MUIInput label='Status' value={staticData.status} disabled />
                            )}
                            <MUIInput
                                label='Map Code'
                                value={staticData.mapCode}
                                onChange={(e) => onChangeInput('mapCode', e.target.value)}
                                disabled={!isCreateMode}
                                error={error.mapCode}
                            />
                            <MUIInput
                                label='Map Value'
                                value={staticData.mapValue}
                                onChange={(e) => onChangeInput('mapValue', e.target.value)}
                                disabled={
                                    staticData.actionType === ACTION_TYPE.PRODUCT ||
                                    staticData.actionType === ACTION_TYPE.PRODUCT_BRAND ||
                                    staticData.actionType === ACTION_TYPE.PRODUCT_CATEGORY ||
                                    staticData.actionType === ACTION_TYPE.E_COUPON ||
                                    staticData.actionType === ACTION_TYPE.E_COUPON_CATEGORY ||
                                    staticData.actionType === ACTION_TYPE.E_COUPON_BRAND ||
                                    staticData.actionType === ACTION_TYPE.FOLDER ||
                                    staticData.actionType === ACTION_TYPE.REST ||
                                    staticData.actionType === ACTION_TYPE.MY_TICKET ||
                                    staticData.actionType === ACTION_TYPE.TRANSFORM_TICKET_FROM_PAPER ||
                                    staticData.actionType === ACTION_TYPE.TRANSFORM_ECOUPON_FROM_PAPER ||
                                    staticData.actionType === ACTION_TYPE.EXPRESS_TICKET_VOUCHER ||
                                    staticData.actionType === ACTION_TYPE.SHARE ||
                                    staticData.actionType === ACTION_TYPE.GIFT
                                }
                            />
                            <MUIInput
                                label='Rest Url Id (反掃用)'
                                value={staticData.restUrlId}
                                onChange={(e) => onChangeInput('restUrlId', e.target.value)}
                            />
                            <MUISelect
                                label='Agent Type'
                                value={staticData.agentType}
                                onChange={(option) => onChangeInput('agentType', option?.value)}
                                options={AGENT_TYPE_OPTION}
                                required
                                error={error.agentType}
                            />
                            {staticData.agentType === 'web' && (
                                <>
                                    <MUISelect
                                        label='Action Type'
                                        value={staticData.actionType}
                                        onChange={(option) =>
                                            onChangeInput('actionType', option?.value)
                                        }
                                        options={ACTION_TYPE_OPTION}
                                        required
                                        showClearEndAdornment
                                        error={error.actionType}
                                    />
                                    {/* Other Data */}
                                    {dynamicDataFields.includes('action') &&
                                        (staticData.actionType === ACTION_TYPE.REST ? (
                                            staticData.restUrlType === REST_URL_TYPE.downloadHtml && (
                                                <MUISelect
                                                    label='Action'
                                                    value={dynamicData.action}
                                                    onChange={(option) =>
                                                        onChangeInput(
                                                            'action',
                                                            option?.value,
                                                            'other'
                                                        )
                                                    }
                                                    options={ACTION_OPTION}
                                                    showClearEndAdornment
                                                    error={error.action}
                                                />
                                            )
                                        ) : (
                                            <MUIInput
                                                label='Action'
                                                value={dynamicData.action}
                                                onChange={(e) =>
                                                    onChangeInput('action', e.target.value, 'other')
                                                }
                                                required
                                                error={error.action}
                                            />
                                        ))}
                                    {dynamicDataFields.includes('title') && (
                                        <MUIInput
                                            label='Title'
                                            value={dynamicData.title}
                                            onChange={(e) =>
                                                onChangeInput('title', e.target.value, 'other')
                                            }
                                            showClearEndAdornment
                                        />
                                    )}
                                    {staticData.actionType === ACTION_TYPE.REST && (
                                        <Box
                                            sx={{
                                                gridColumn: '1 / -1',
                                                display: 'grid',
                                                gridTemplateColumns: 'repeat(3, 1fr)',
                                                gap: 1,
                                            }}
                                        >
                                            <MUISelect
                                                label='Restaurant URL Type'
                                                value={staticData.restUrlType}
                                                onChange={(option) =>
                                                    onChangeInput('restUrlType', option.value)
                                                }
                                                options={REST_URL_TYPE_OPTION}
                                                required
                                                error={error.restUrlType}
                                            />
                                            {staticData.restUrlType !== REST_URL_TYPE.other && (
                                                <MUIInput
                                                    label='Rest Url Id'
                                                    value={dynamicData.queryRestUrlId}
                                                    onChange={(e) =>
                                                        onChangeInput(
                                                            'queryRestUrlId',
                                                            e.target.value,
                                                            'other'
                                                        )
                                                    }
                                                    required
                                                    endAdornment={<OpenDrawerEndAdornment />}
                                                    error={error.queryRestUrlId}
                                                />
                                            )}
                                        </Box>
                                    )}
                                    {dynamicDataFields.includes('name') && (
                                        <MUIInput
                                            label='Name'
                                            value={dynamicData.name}
                                            onChange={(e) =>
                                                onChangeInput('name', e.target.value, 'other')
                                            }
                                            showClearEndAdornment
                                        />
                                    )}
                                    {dynamicDataFields.includes('query') && (
                                        <MUISelect
                                            label='Query'
                                            value={dynamicData.query}
                                            groupCode
                                            onChange={(option) =>
                                                onChangeInput('query', option?.value, 'other')
                                            }
                                            options={QUERY_OPTION}
                                            showClearEndAdornment
                                        />
                                    )}
                                    {dynamicDataFields.includes('ticketId') && (
                                        <MUIInput
                                            label='Ticket Id'
                                            value={dynamicData.ticketId}
                                            onChange={(e) =>
                                                onChangeInput('ticketId', e.target.value, 'other')
                                            }
                                            required
                                            error={error.ticketId}
                                        />
                                    )}
                                    {dynamicDataFields.includes('infoId') && (
                                        <MUIInput
                                            label='Info Id'
                                            value={dynamicData.infoId}
                                            onChange={(e) =>
                                                onChangeInput('infoId', e.target.value, 'other')
                                            }
                                            required
                                            error={error.infoId}
                                        />
                                    )}
                                    {dynamicDataFields.includes('groupCode') && (
                                        <MUIInput
                                            label='Group Code'
                                            value={dynamicData.groupCode}
                                            onChange={(e) =>
                                                onChangeInput('groupCode', e.target.value, 'other')
                                            }
                                            required
                                            error={error.groupCode}
                                        />
                                    )}
                                    {dynamicDataFields.includes('refId') && (
                                        <MUIInput
                                            label='Ref Id'
                                            value={dynamicData.refId}
                                            onChange={(e) =>
                                                onChangeInput('refId', e.target.value, 'other')
                                            }
                                            required
                                            error={error.refId}
                                        />
                                    )}
                                    {dynamicDataFields.includes('code') && (
                                        <MUIInput
                                            label='Code'
                                            value={dynamicData.code}
                                            onChange={(e) =>
                                                onChangeInput('code', e.target.value, 'other')
                                            }
                                            required
                                            error={error.code}
                                        />
                                    )}
                                    {dynamicDataFields.includes('serviceType') && (
                                        <MUISelect
                                            label='Service Type'
                                            value={dynamicData.serviceType}
                                            onChange={(option) =>
                                                onChangeInput('serviceType', option.value, 'other')
                                            }
                                            options={
                                                staticData.actionType === ACTION_TYPE.GIFT
                                                    ? GIFT_SERVICE_TYPE_OPTION
                                                    : SERVICE_TYPE_OPTION
                                            }
                                            required
                                            error={error.serviceType}
                                        />
                                    )}
                                    {dynamicDataFields.includes('productCode') && (
                                        <MUIInput
                                            label='Product Code'
                                            value={dynamicData.productCode}
                                            onChange={(e) =>
                                                onChangeInput(
                                                    'productCode',
                                                    e.target.value,
                                                    'other'
                                                )
                                            }
                                            required
                                            endAdornment={<OpenDrawerEndAdornment />}
                                            error={error.productCode}
                                        />
                                    )}
                                    {dynamicDataFields.includes('eCouponCode') && (
                                        <MUIInput
                                            label='E-Coupon Code'
                                            value={dynamicData.eCouponCode}
                                            onChange={(e) =>
                                                onChangeInput(
                                                    'eCouponCode',
                                                    e.target.value,
                                                    'other'
                                                )
                                            }
                                            required
                                            endAdornment={<OpenDrawerEndAdornment />}
                                            error={error.eCouponCode}
                                        />
                                    )}
                                    {(dynamicData.productCode || dynamicData.eCouponCode) && (
                                        <MUISelect
                                            label='Brand / Category'
                                            value={dynamicData.codeType}
                                            onChange={(option) =>
                                                onChangeInput('codeType', option?.value, 'other')
                                            }
                                            options={CODE_TYPE_OPTION}
                                            showClearEndAdornment
                                        />
                                    )}
                                    {dynamicDataFields.includes('type') && (
                                        <MUISelect
                                            label='Type'
                                            value={dynamicData.type}
                                            onChange={(option) =>
                                                onChangeInput('type', option?.value, 'other')
                                            }
                                            options={
                                                dynamicData.serviceType === 'RACK_PRODUCT'
                                                    ? RACK_PRODUCT_TYPE_OPTION
                                                    : WEB_VIEW_TYPE_OPTION
                                            }
                                            error={error.type}
                                            required={dynamicData.serviceType === 'RACK_PRODUCT'}
                                            showClearEndAdornment={
                                                staticData.actionType === ACTION_TYPE.WEB_VIEW
                                            }
                                        />
                                    )}
                                    {(dynamicDataFields.includes('categoryCode') ||
                                        dynamicData.codeType === 'CATEGORY') && (
                                        <MUIInput
                                            label='Category Code'
                                            value={dynamicData.categoryCode}
                                            onChange={(e) =>
                                                onChangeInput(
                                                    'categoryCode',
                                                    e.target.value,
                                                    'other'
                                                )
                                            }
                                            required
                                            endAdornment={<OpenDrawerEndAdornment />}
                                            error={error.categoryCode}
                                        />
                                    )}
                                    {(dynamicDataFields.includes('brandCode') ||
                                        dynamicData.codeType === 'BRAND') && (
                                        <MUIInput
                                            label='Brand Code'
                                            value={dynamicData.brandCode}
                                            onChange={(e) =>
                                                onChangeInput('brandCode', e.target.value, 'other')
                                            }
                                            required
                                            endAdornment={<OpenDrawerEndAdornment />}
                                            error={error.brandCode}
                                        />
                                    )}
                                    {dynamicDataFields.includes('folderCode') && (
                                        <MUIInput
                                            label='Folder Code'
                                            value={dynamicData.folderCode}
                                            onChange={(e) =>
                                                onChangeInput('folderCode', e.target.value, 'other')
                                            }
                                            required
                                            endAdornment={<OpenDrawerEndAdornment />}
                                            error={error.folderCode}
                                        />
                                    )}
                                    {dynamicDataFields.includes('folderType') && (
                                        <MUISelect
                                            label='Folder Type'
                                            value={staticData.folderType}
                                            onChange={(option) =>
                                                onChangeInput('folderType', option?.value, ' other')
                                            }
                                            options={FOLDER_TYPE_OPTION}
                                            showClearEndAdornment
                                        />
                                    )}
                                    {staticData.restUrlType !== REST_URL_TYPE.universal &&
                                        staticData.restUrlType !== REST_URL_TYPE.other && (
                                            <Box
                                                sx={{
                                                    gridColumn: '1 / -1',
                                                    display: 'grid',
                                                    gridTemplateColumns: 'repeat(3, 1fr)',
                                                    gap: 1,
                                                }}
                                            >
                                                <MUISelect
                                                    label='From'
                                                    value={dynamicData.from}
                                                    onChange={(option) =>
                                                        onChangeInput(
                                                            'from',
                                                            option?.value,
                                                            'other'
                                                        )
                                                    }
                                                    options={FROM_OPTION}
                                                    showClearEndAdornment
                                                />
                                            </Box>
                                        )}
                                    {(dynamicDataFields.includes('customUrl') ||
                                        staticData.restUrlType === REST_URL_TYPE.other) && (
                                        <MUIInput
                                            label='Custom URL'
                                            value={dynamicData.customUrl}
                                            onChange={(e) =>
                                                onChangeInput('customUrl', e.target.value, 'other')
                                            }
                                            required
                                            sx={{ gridColumn: '1 / -1' }}
                                            error={error.customUrl}
                                        />
                                    )}
                                </>
                            )}
                            {staticData.agentType === 'weChat' && (
                                <MUIInput
                                    label='WeChat'
                                    value={dynamicData.weChat}
                                    onChange={(e) => {
                                        onChangeInput('weChat', e.target.value, 'other')
                                        setUrl(
                                            `${Q_HK_WALLET_URL}${
                                                e.target.value ? `?${e.target.value}` : ''
                                            }`
                                        )
                                    }}
                                    showClearEndAdornment
                                />
                            )}
                            <MUIInput
                                label='URL'
                                value={url}
                                disabled
                                sx={{ gridColumn: '1 / -1' }}
                            />
                        </GridContainer>
                        {!isCreateMode && showQrCode && (
                            <Box sx={{ display: 'flex', flexDirection: 'column', p: 2, gap: 2 }}>
                                <QRCode
                                    id='qrCode'
                                    size={150}
                                    value={staticData.qrCodeUrl}
                                    level={'L'}
                                    renderAs={'svg'}
                                />
                                <Button
                                    variant='contained'
                                    onClick={onClickDownloadQrCode}
                                    startIcon={<GetApp />}
                                    sx={{ width: 'fit-content' }}
                                >
                                    Download QR Code
                                </Button>
                                <a target='_blank' rel='noopener noreferrer' href={staticData.qrCodeUrl}>
                                    {staticData.qrCodeUrl}
                                </a>
                            </Box>
                        )}
                    </Stack>
                </CardContent>
                <CardActions>
                    <Button
                        variant='contained'
                        onClick={onClickSave}
                        startIcon={<Save />}
                        disabled={Object.values(error).some((error) => error)}
                    >
                        Save
                    </Button>
                    <Button variant='contained' onClick={onClickClear} startIcon={<Clear />}>
                        Clear
                    </Button>
                </CardActions>
            </Card>
            <Drawer
                anchor='right'
                open={openDrawer}
                onClose={onCloseDrawer}
                PaperProps={{
                    sx: {
                        width: '80%',
                    },
                }}
            >
                {renderDrawerList()}
            </Drawer>
            {openDialog && (
                <SharedDialog
                    content={`${isCreateMode ? 'Create' : 'Edit'} Successful!`}
                    actions={
                        <>
                            <Button
                                variant='contained'
                                onClick={onClickBackToCreateEdit}
                                startIcon={<ArrowBack />}
                            >
                                {`Back To ${isCreateMode ? 'Create' : 'Edit'}`}
                            </Button>
                            <Button
                                variant='contained'
                                onClick={onClickBackToList}
                                startIcon={<List />}
                            >
                                Back To Listing
                            </Button>
                        </>
                    }
                    open={openDialog}
                />
            )}
        </>
    )
}
